import { render } from "./UpdateStudentStandartCarrying.vue?vue&type=template&id=6dee043b"
import script from "./UpdateStudentStandartCarrying.vue?vue&type=script&lang=js"
export * from "./UpdateStudentStandartCarrying.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__